module.exports = __webpack_public_path__ + "static/media/before-you-start.d6cd9efd.svg";